import styles from './styles.module.scss';
import { LoaderContext } from '../App';
import { Loader } from '../components';
import { Header, Footer } from './components';
import { FC, useContext, ReactNode } from 'react';

const Layout: FC<{ children: ReactNode }> = ({ children }) => {
  const {
    loader: { isLoading, title },
  } = useContext(LoaderContext);

  return (
    <>
      {isLoading && <Loader title={title} />}
      <section className={styles['Layout']}>
        <Header />
        <div className={styles['wrapper']}>
          <div className="container">
            <main>{children}</main>
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
};

export { Layout };
